import { render } from "./BasketBottomWidget.vue?vue&type=template&id=abbe5dc6&scoped=true"
import script from "./BasketBottomWidget.vue?vue&type=script&lang=js"
export * from "./BasketBottomWidget.vue?vue&type=script&lang=js"

import "./BasketBottomWidget.vue?vue&type=style&index=0&id=abbe5dc6&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abbe5dc6"]])

export default __exports__